var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.837 213.845h-83.082v-29.882l88.467-1.28-88.661-105.71c-2.93-42.848-38.723-76.81-82.301-76.81h-182.765c-45.488 0-82.495 37.007-82.495 82.495v133.003c0 45.488 37.007 82.495 82.495 82.495h81.75v41.504l-84.882 104.986h86.244c2.949 16.031 10.613 30.862 22.299 42.797 15.403 15.731 35.824 24.394 57.502 24.394h185.43c44.753 0 81.163-36.41 81.163-81.163v-135.666c-.001-44.753-36.41-81.163-81.164-81.163zm-400.853 1.816v-133.003c0-28.955 23.557-52.511 52.511-52.511h182.766c28.954 0 52.511 23.557 52.511 52.511v5.455l54.937 65.501-54.937.795v59.434h-72.364c-35.351 0-65.477 22.726-76.583 54.328h-86.33c-28.955.002-52.511-23.555-52.511-52.51zm452.032 215.013c0 28.22-22.959 51.179-51.179 51.179h-185.43c-13.549 0-26.362-5.465-36.078-15.388-9.738-9.945-15.101-23.018-15.101-36.811v-14.992h-52.065l52.065-64.397v-55.258c0-28.22 22.959-51.179 51.179-51.179h185.43c28.22 0 51.179 22.959 51.179 51.179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.44 347.253h29.984v29.986h-29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.594 347.253h29.984v29.986h-29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.561 347.253h29.984v29.986h-29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.142 127.345h29.984v29.986h-29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.296 127.345h29.984v29.986h-29.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.263 127.345h29.984v29.986h-29.984z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversation);
export default __webpack_public_path__ + "static/media/conversation.665bae8b00b4b07500fb21cdce946317.svg";
export { ForwardRef as ReactComponent };